<div class="dialog">
  <h2>
    Bulk Import Gems
  </h2>

  <div class="filter-group">
    <div class="filter-group-header">
      <div class="filter">
        <span class="filter-body">
          <span filter-title text="Type or Paste Gem Names">
            <ul>
              <li>You can copy/paste any text, the gems will be automatically detected.</li>
              <li>Color codes added by Path of Building are are stripped out and can be parsed.</li>
              <li>Short-form names for support gems are supported. E.g.: 'added lightning' and 'lightning damage' will both be translated into 'Added Lightning Damage Support'.</li>
              <li>Transfigured gems are no actual separate Gem Base Types, and thus their non-transfigured variants are selected. This applies to Trarthan Gems too.</li>
            </ul>
          </span>
        </span>
      </div>
    </div>
    <div class="filter-group-body">

      <textarea #importTextElement name="importText" class="custom-rules" [(ngModel)]="importText" (keyup)="parseImportText()"></textarea>

    </div>
  </div>

  <div class="filter-group">
    <div class="filter-group-header">
      <div class="filter">
        <span class="filter-body">
          <span class="filter-title">
            Detected Gems ({{selectedGems.length}})
          </span>
        </span>
      </div>
    </div>
    <div class="filter-group-body">
      <div class="detected-gems-container">
        @for (gem of selectedGems; track gem.name) {
          <app-item-label [baseType]="gem.name" [image]="gem.image" [gem]="true"></app-item-label>
        }
        @if (selectedGems.length === 0) {
          <span class="extra-info">No gems detected. Type or paste gem names in the text area above.</span>
        }
      </div>
    </div>
  </div>

  <div class="controls dialog-controls">
    <button type="button" class="btn dialog-btn dialog-main-btn" (click)="importGems()">
      Import
    </button>
    <button type="button" class="btn dialog-btn dialog-cancel-btn" (click)="closeDialog()">
      Cancel
    </button>
  </div>
</div>
